import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';

import {LocalStorage, LocalStorageService, SessionStorage, SessionStorageService} from 'angular-web-storage';
import { environment } from '../../environments/environment';

import {
  AuthService,
  FacebookLoginProvider,
  GoogleLoginProvider
} from 'angular-6-social-login';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {User} from '../models/app.model';
import {ActivatedRoute, Router} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  accountTitle: string;
  accountInfoPara1: SafeHtml;
  accountInfoPara2: SafeHtml;
  accountInfoPara3: SafeHtml;
  appPrivilegesList: any;
  currentPrivilege: string;

  loginType: number;
  user: User;

  privilegeAllCount: string;

  userCredential: any;
  accessPrivileges: string;
  freePrivilege: number;

  constructor(
    private _appService: AppService,
    private socialAuthService: AuthService,
    private sanitizer: DomSanitizer,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private _route: ActivatedRoute,
    private _router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();
    this.freePrivilege = 0;

    if (this._route.snapshot.params.privilege) {
      this.freePrivilege = this._route.snapshot.params.privilege;
    }

    this.getConfigDataServiceByPage('account').subscribe(res => {
      this.accountTitle     = res['conf_account_title']['config_val'];
      this.accountInfoPara1 = this.sanitizer.bypassSecurityTrustHtml(res['conf_account_para1']['config_val']);
      this.accountInfoPara2 = this.sanitizer.bypassSecurityTrustHtml(res['conf_account_para2']['config_val']);
      this.accountInfoPara3 = this.sanitizer.bypassSecurityTrustHtml(res['conf_account_para3']['config_val']);
      this.spinner.hide();
    });

    this._appService.getAllAppPrivileges().subscribe(res => {
      this.appPrivilegesList = res;
      this.privilegeAllCount = res['length'];
    });

    if (this.localStorage.get('sociaKey') != null && this.localStorage.get('sociaKey').userEmail != null) {
      console.log(this.localStorage.get('sociaKey'));
      this.userCredential = this.localStorage.get('sociaKey');
      this._appService.getUserData(this.localStorage.get('sociaKey').userEmail).subscribe(res => {
        console.log(res['pri_val']);
        this.currentPrivilege = res['pri_val'];
        this.accessPrivileges = this.currentPrivilege;
        this.sessionStorage.set('accessPrivileges', res['pri_val']);
      });
    } else {
      console.log(environment.appPrivilege);
      this.currentPrivilege = environment.appPrivilege;
      this.sessionStorage.set('accessPrivileges', environment.appPrivilege);
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    }
  }

  filterPrivilege(currentPri) {
    if (this.appPrivilegesList) {
      return this.appPrivilegesList.filter(x => x.pri_val > currentPri);
    } else {
     return null;
    }
  }

  getConfigDataServiceByPage(pageName: string) {
    return this._appService.getConfigDataByPage(pageName);
  }

  public logoutSociaLogin () {
    this.currentPrivilege = environment.appPrivilege;
    this.userCredential = null;
    this.localStorage.remove('sociaKey');
    this.sessionStorage.set('accessPrivileges', environment.appPrivilege);
    this.accessPrivileges = environment.appPrivilege;
  }

  public socialSignIn(socialPlatform: string) {
    let socialPlatformProvider;
    if (socialPlatform === 'facebook') {
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
      this.loginType = 1;
    } else if (socialPlatform === 'google') {
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
      this.loginType = 2;
    }

    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        const currentPrivilege = this.currentPrivilege;
        this.user = {useremail: userData.email, userpricurrent: currentPrivilege, userlogintype: this.loginType};

        this._appService.updateAddUserData(this.user).subscribe(res => {
          console.log(res);
          let userPrivilege;

          if (res['user_privilege']) {
            userPrivilege = res['user_privilege'];
          } else {
            userPrivilege = currentPrivilege;
          }

          this.currentPrivilege = userPrivilege;
          this.accessPrivileges = userPrivilege;
          this.userCredential = { 'userEmail': userData.email, 'userFullName': userData.name, 'userImage': userData.image, 'userPrivilege': userPrivilege};

          this.localStorage.set('sociaKey', this.userCredential);

        });
      }
    );
  }

}
